import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../../../context/CheckoutSettings/context.js';
import '@swc/helpers';
import { mapShippingMethods } from '../../../../mappers/view/shipping-methods.js';
import '../../../../mappers/errors-mapping.js';
import { ShippingMethodInfo } from '../../../modules/ShippingMethods/components/ShippingMethodInfo.js';
import { useShippingMethodsList } from '../../../modules/ShippingMethods/hooks/use-shipping-methods-list.js';

const useGroupedShippingMethods = (allowedKeys, onShippingMethodsLoadCompleted)=>{
    const { locale  } = useIntl();
    const { shippingMethodsLogos  } = useCheckoutSettings();
    const { shippingMethodList , isLoading , error  } = useShippingMethodsList(onShippingMethodsLoadCompleted);
    const shippingMethodInfo = ({ price , logo , isFree  })=>/*#__PURE__*/ React.createElement(ShippingMethodInfo, {
            price: price,
            logo: logo,
            isFree: isFree
        })
    ;
    const items = mapShippingMethods({
        logos: shippingMethodsLogos,
        locale,
        shippingMethodList,
        shippingMethodInfo
    });
    return {
        groupedShippingMethods: React.useMemo(()=>items.filter((item)=>allowedKeys.includes(item.value)
            )
        , [
            allowedKeys,
            items
        ]),
        error,
        isLoading
    };
};

export { useGroupedShippingMethods };
//# sourceMappingURL=use-grouped-shipping-methods.js.map
